import type { SortOrder } from "../i18n/messages.js";
import type { ProductCardDTO } from "../api/types.js";
import { AVAILABILITY_SORT_RANK, normalizeAvailabilityFromStock } from "./format.js";

function availabilityRank(product: ProductCardDTO): number {
  const key = product.availability ?? normalizeAvailabilityFromStock(product.stock_status);
  return AVAILABILITY_SORT_RANK[key] ?? 99;
}

export function sortProducts(products: ProductCardDTO[], order: SortOrder): ProductCardDTO[] {
  const copy = [...products];
  switch (order) {
    case "price_asc":
      return copy.sort((a, b) => (a.price_amount ?? Number.MAX_SAFE_INTEGER) - (b.price_amount ?? Number.MAX_SAFE_INTEGER));
    case "price_desc":
      return copy.sort((a, b) => (b.price_amount ?? -1) - (a.price_amount ?? -1));
    case "name":
      return copy.sort((a, b) => a.title.localeCompare(b.title, "uk"));
    case "default":
    default:
      return copy.sort((a, b) => {
        const byAvailability = availabilityRank(a) - availabilityRank(b);
        if (byAvailability !== 0) {
          return byAvailability;
        }
        const byPrice = (a.price_amount ?? Number.MAX_SAFE_INTEGER) - (b.price_amount ?? Number.MAX_SAFE_INTEGER);
        if (byPrice !== 0) {
          return byPrice;
        }
        return a.title.localeCompare(b.title, "uk");
      });
  }
}
